<!-- FOR SMALL SCREENS -->
<p-menubar class="flex md:hidden bg-black-dark mobile-menu" [model]="mobileItems()" [attr.data-test-id]="'core-layout-navbar-mobileMenu' | dataTestId">
    <div class="flex flex-row  items-center">
        <div class="flex text-muted-color grow justify-center" >
            <a [routerLink]="homeRouterLink">
                <img src="../../../../assets/images/adi-logo.svg" style="height: 28px" />
            </a>
        </div>
        <p-menu #menu [model]="currentUserItems()" [popup]="true" [dt]="navbarMenu"
            [attr.data-test-id]="'core-layout-navbar-userMobileMenu' | dataTestId"></p-menu>
        <button type="button" (click)="menu.toggle($event)" class="flex p-0 border-0 cursor-pointer" style="background-color: transparent;"
            [attr.data-test-id]="'core-layout-navbar-userMobileMenuButton' | dataTestId">
            <img alt="logo" src="../../../../assets/icons/ico-user.svg" class="sidepanel-icon" />
        </button>
    </div>
</p-menubar>

<!-- FOR LARGER SCREENS -->
<p-menubar class="menubar-height hidden md:flex">
    <ng-template #start>
        <a [routerLink]="homeRouterLink">
            <img src="../../../../assets/images/adi-logo.svg" style="height: 30px" class="ml-2" />
        </a>
    </ng-template>
    <ng-template #end>
        <div class="flex items-center">
            <a (click)="notificationPopover?.notificationPopup()?.toggle($event)" class="no-underline cursor-pointer mr-4" i18n-title title="Notifications">
                <p-overlay-badge [dt]="overlayBadgeDt" [badgeDisabled]="!notificationPopover.existsUnreadNotification()">
                    <span class="pi pi-bell text-muted-color text-2xl"></span>
                </p-overlay-badge>
            </a>
            <a [href]="documentationUrl" target="_blank" class="mr-4 no-underline" i18n-title title="Documentation" [attr.data-test-id]="'core-layout-navbar-documentation' | dataTestId">
                <span class="pi pi-book text-muted-color text-2xl"></span>
            </a>
            <img alt="user" src="../../../../assets/icons/ico-user.svg" class="mr-2"/>
            <p-menu #menu [model]="currentUserItems()" [popup]="true"[dt]="navbarMenu"  [attr.data-test-id]="'core-layout-navbar-userMenu' | dataTestId"></p-menu>
            <p-button [outlined]="true" styleClass="p-button-sm text-muted-color border-text-secondary"
                (click)="menu.toggle($event)" [attr.data-test-id]="'core-layout-navbar-userMenuButton' | dataTestId">{{currentUserName()}}</p-button>
        </div>
    </ng-template>
</p-menubar>

<div #notificationContainer></div>

<app-notifications-popover #notificationPopover 
                           [appendTo]="notificationContainer">
</app-notifications-popover>